<template>
  <div class="right-now">
    <div class="ping">
      <div class="ping-a ping-animation"></div>
      <div class="ping-a ping-animation animation-delay"></div>
      <div class="ping-circle"></div>
    </div>
    <div class="ping-text" v-text="$t('rightNow')"/>
  </div>

</template>

<script>
export default {
  name: "RightNow"
}
</script>

<style>
.ping-animation {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}

@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}

.right-now {
  display: flex;
  align-items: center;
  position: relative;
}

.ping {
  position: relative;
  margin-right: 6px;
}
.ping-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 130%;
  color: #003882;
}
.ping-circle {
  width: 8px;
  height: 8px;
  background-color: #003882;
  border-radius: 100%;
}
.ping-a {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #003882;
  border-radius: 100%;
}
</style>